/**
 * Format currency amount
 * Handles invalid values (NaN, null, undefined, "не число", etc.) by returning "0"
 */
export const formatCurrency = (amount) => {
    // Handle string "не число" or other invalid strings
    if (typeof amount === 'string' && (amount.trim() === 'не число' || amount.trim() === '' || isNaN(Number(amount)))) {
        return '0';
    }
    
    // Convert to number and validate
    const numAmount = Number(amount);
    
    // Handle NaN, null, undefined, or invalid numbers
    if (isNaN(numAmount) || numAmount === null || numAmount === undefined) {
        return '0';
    }
    
    return new Intl.NumberFormat('ru-RU').format(numAmount);
};

/**
 * Format currency for totals row - show "0" instead of "-"
 * Handles invalid values (NaN, null, undefined, "не число", etc.) by returning "0"
 */
export const formatCurrencyForTotal = (amount) => {
    // Handle string "не число" or other invalid strings
    if (typeof amount === 'string' && (amount.trim() === 'не число' || amount.trim() === '' || isNaN(Number(amount)))) {
        return '0';
    }
    
    // Convert to number and validate
    const numAmount = Number(amount);
    
    // Handle NaN, null, undefined, or invalid numbers
    if (isNaN(numAmount) || numAmount === null || numAmount === undefined) {
        return '0';
    }
    
    // Always format as number, even if 0 (changed from "-" to "0")
    return new Intl.NumberFormat('ru-RU').format(numAmount);
};

